import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import userService from 'services/UserService';
import ComponentContainer from 'containers/ComponentContainer';
import ForgotPasswordWeb from './ForgotPasswordWeb';
import ForgotPasswordMobile from './ForgotPasswordMobile';

class ForgotPasswordWrapper extends Component {
    state = {
        loading: true,
        email: ''
    };
    render() {
        const { loginConfig } = this.props;

        return (
            <ComponentContainer loading={this.state.loading}>
                {(props) => {
                    this.parentProps = props;
                    return (
                        <div>
                            {loginConfig && loginConfig.formType === 'web' ?
                                <ForgotPasswordWeb data={this.state} onSubmit={this.handleSubmit} loginConfig={loginConfig || {}} />
                                :
                                <ForgotPasswordMobile data={this.state} onSubmit={this.handleSubmit} loginConfig={loginConfig || {}} intl={this.parentProps.intl} />
                            }
                        </div>
                    );
                }}
            </ComponentContainer>
        );    }

    handleSubmit = (values, props) => {
        const { history, location } = this.props;
        const { setSubmitting } = props;
        const { email } = values;

        setSubmitting(true);

        // can't use URLSearchParams here because it messes up the URL encoding, just take the whole string and remove parameter
        const returnUrl = location.search.replace('?ReturnUrl=', '');
        const params = location.search.replace('?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback', '')
            .replace(new RegExp(/%3F/, 'g'), '?')
            .replace(new RegExp(/%26/, 'g'), '&')
            .replace(new RegExp(/%3D/, 'g'), '=');

        userService
            .sendResetPasswordEmail(email, returnUrl)
            .then(() => setSubmitting(false))
            .finally(() => history.push('/app/ForgotPasswordConfirmation' + params));
    };

    componentDidMount() {
        if (this.props.loginConfig) {
            this.setState({ loading: false });
        }
    }
}

export default withRouter(ForgotPasswordWrapper);
